import { get } from "../shared/api-client";
import type { ApiItemResponse } from "@project/types/location";
import type { HealthcareDashboardData } from "@project/types/healthcare-dashboard";
import { JIVANDHARA_BASE, unwrapItem } from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/healthcare-dashboard`;

class HealthcareDashboardService {
  fetch = async (): Promise<HealthcareDashboardData | undefined> => {
    const data = await get<ApiItemResponse<HealthcareDashboardData> | HealthcareDashboardData>(
      `${BASE}/`,
      { showNotification: false }
    );
    return unwrapItem(data);
  };
}

export const healthcareDashboardService = new HealthcareDashboardService();
